export const TEMA_PADRAO = {
  primary: "#000000",
  secondary: "#ffd600",
  accent: "#ffd600",
  error: "#D50000",
  warning: "#FF8F00",
  info: "#448aff",
  success: "#43a047",
};

export const TEMA_CLIENTE = {
  primary: "#000000",
  secondary: "#ffd600",
  accent: "#ffd600",
  error: "#D50000",
  warning: "#FF8F00",
  info: "#448aff",
  success: "#43a047",
};

export const TEMA_FORNECEDOR = {
  primary: "#000000",
  secondary: "#ff5252",
  accent: "#ff5252",
  error: "#D50000",
  warning: "#FF8F00",
  info: "#448aff",
  success: "#43a047",
};

// accent: "#b388ff",

export const TEMA_REPRESENTANTE = {
  primary: "#000000",
  secondary: "#40c4ff",
  accent: "#40c4ff",
  error: "#D50000",
  warning: "#FF8F00",
  info: "#448aff",
  success: "#43a047",
};

export const TEMA_MASTER = {
  primary: "#000000",
  secondary: "#64dd17",
  accent: "#64dd17",
  error: "#D50000",
  warning: "#FF8F00",
  info: "#448aff",
  success: "#43a047",
};

export const TEMA_ADMINISTRADOR = {
  primary: "#000000",
  secondary: "#cfd8dc",
  accent: "#cfd8dc",
  error: "#D50000",
  warning: "#FF8F00",
  info: "#448aff",
  success: "#43a047",
};
